<template>
  <div class="ht-side-bar">
    <el-scrollbar
      class="side-bar-container"
      :class="{ 'is-collapse': collapse }"
      :style="{ background: variables[`${style}-menu-background`] }"
    >
      <el-menu
        class="side-bar-menu"
        :background-color="variables[`${style}-menu-background`]"
        :text-color="variables[`${style}-menu-color`]"
        :active-text-color="themeColor"
        :default-active="activeMenu"
        :collapse="collapse"
        :collapse-transition="false"
        :default-openeds="defaultOpens"
        :unique-opened="uniqueOpened"
        mode="vertical"
      >
        <template v-for="route in routes">
          <ht-side-bar-item
            :key="route.id"
            :full-path="route.path"
            :item="route"
          />
        </template>
      </el-menu>
    </el-scrollbar>

    <div :class="['side-bar-fold', collapse ? 'fold' : 'unfold']">
      <i
        :class="[collapse ? 'icon-fold' : 'icon-unfold']"
        :title="collapse ? $t('eip.common.expand') : $t('eip.common.collapse')"
        class="fold-unfold"
        @click="handleCollapse"
      />
    </div>
  </div>
</template>
<script>
  import variables from '@/styles/variables.scss'
  import { mapActions, mapGetters } from 'vuex'
  import { defaultOpens, uniqueOpened } from '@/config'

  export default {
    name: 'HtSideBar',
    data() {
      return {
        uniqueOpened,
        variables,
      }
    },
    computed: {
      ...mapGetters({
        collapse: 'settings/collapse',
        style: 'settings/style',
        routes: 'routes/routes',
        themeColor: 'settings/themeColor',
      }),
      defaultOpens() {
        return defaultOpens
      },
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
    },
    methods: {
      ...mapActions({
        changeCollapse: 'settings/changeCollapse',
      }),
      handleCollapse() {
        this.changeCollapse()
      },
    },
  }
</script>
<style lang="scss" scoped>
  @mixin dot-border-color {
    border-color: var(--themeColor);
  }

  .ht-side-bar {
    display: flex;
    flex-direction: column;
    height: 100%;

    .side-bar-container {
      flex: 1;
      width: $base-left-menu-width;
      overflow: hidden;
      transition: width $base-transition-time;

      .side-bar-menu {
        > .el-submenu {
          color: saddlebrown;
          ::v-deep > .el-submenu__title {
            color: skyblue;
            > .sub-menu-title {
              font-weight: bold;
              color: #414650;
            }
          }
        }
      }

      &.is-collapse {
        width: $base-left-menu-width-min;
        border-right: 0;

        ::v-deep {
          .el-menu {
            transition: width $base-transition-time;
          }

          .el-menu--collapse {
            border-right: 0;

            .el-menu-item,
            .el-submenu__title {
              text-overflow: unset;
            }

            .el-submenu__icon-arrow {
              right: 10px;
              margin-top: -3px;
            }
          }
        }
      }

      ::v-deep {
        .el-scrollbar__wrap {
          height: 100%;
          overflow-x: hidden;
        }

        .el-menu {
          border: 0;

          .ht-fa-icon {
            font-size: $base-font-size-big;
            color: $base-menu-icon-color;
          }

          .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
            color: var(--themeColor);
            transform: rotateZ(0deg);
          }

          .el-submenu {
            .is-active {
              .sub-menu-child__title {
                &::before {
                  background: $base-color-white;
                  @include dot-border-color;
                }
              }
            }

            .el-menu-item {
              display: flex;
              align-items: center;
              height: $base-menu-item-height;
              line-height: unset;
            }

            .sub-menu-child__title {
              padding-left: 22px;
              overflow: hidden;
              color: #8f99ac;
              text-overflow: ellipsis;
            }
          }

          .el-submenu {
            .el-submenu {
              .el-submenu__title {
                padding-left: 41px !important;

                .ht-fa-icon {
                  display: none;
                }
              }

              .sub-menu-child__title {
                padding-left: 22px;
              }
            }
          }
        }

        .el-menu-item,
        .el-submenu__title {
          display: flex;
          align-items: center;
          width: 100%;
          height: $base-menu-height;
          padding-right: 20px;
          padding-left: $base-menu-item-padding-left !important;
          overflow: hidden;
          line-height: unset;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: middle;

          .ht-fa-icon {
            color: #5f737f;
          }

          .sub-menu-title {
            display: inline-block;
            width: 96px;
            overflow: hidden;
            color: #8f99ac;
            text-overflow: ellipsis;
          }
          .el-menu--horizontal > .el-menu-item {
            color: red;
          }
        }
      }
    }

    .side-bar-fold {
      display: flex;
      flex: none;
      align-items: center;
      height: 50px;
      padding: 0 20px;
      background: #fff;

      &.fold {
        justify-content: center;
        padding: 0;
      }

      &.unfold {
        justify-content: flex-end;
      }

      .fold-unfold {
        font-size: $base-font-size-default;
        line-height: 100%;
        color: #89919a;
        cursor: pointer;
      }
    }
  }
</style>
